import { GET_USER_HISTORY } from '../../constants/ActionTypes';
import { getCookie } from '../../helpers/getCookie';

const MAX_HISTORY_ITEMS = 4;
const FETCH_TIMEOUT = 11000; // 11 seconds

// const mockData = [
//   {
//     id: '10694',
//     nome: 'Emitir DAS do MEI',
//     url: 'https://www.gov.br/pt-br/servicos',
//     date: 1684153987437,
//   },
//   {
//     id: '9680',
//     nome: 'Atualizar dados do MEI',
//     url: 'https://www.gov.br/pt-br/servicos',
//     date: 1684153972072,
//   },
//   {
//     id: '9918',
//     url: 'https://www.gov.br/pt-br/servicos',
//     nome: 'Atualizar cadastro de conselheiros e nutricionistas junto ao Programa Nacional de Alimentação Escolar (PNAE)',
//     date: '2022-10-31T18:00:00.000Z',
//   },
//   {
//     id: '11601',
//     url: 'https://www.gov.br/pt-br/servicos',
//     nome: 'Emitir o Certificado de Condição de Microempreendedor Individual',
//     date: '2022-10-20T11:00:00.000Z',
//   },
//   {
//     id: '11605',
//     url: 'https://www.gov.br/pt-br/servicos',
//     nome: 'Emitir o Certificado de Condição de Microempreendedor Individual',
//     date: '2022-10-20T11:00:00.000Z',
//   },
// ];

const fetchUserHistoryRequest = () => ({
  type: `${GET_USER_HISTORY}_PENDING`,
});

const fetchUserHistorySuccess = (items) => ({
  type: `${GET_USER_HISTORY}_SUCCESS`,
  payload: items,
});

const fetchUserHistoryFailure = (error) => ({
  type: `${GET_USER_HISTORY}_FAIL`,
  payload: error,
});

const validateHistoryData = (data) => {
  return (
    Array.isArray(data) &&
    data.every((item) => item.id && item.nome && item.url && item.date)
  );
};

const mapUserHistoryOutput = (output) => {
  if (!output || !Array.isArray(output)) {
    return [];
  }

  return output.map((item) => {
    return {
      id: item.id,
      nome: item.title,
      url: item.path,
      date: new Date(item['date-hour']),
    };
  });
};

// Verifica se os dados estão expirados com base na última vez que foram buscados
const isDataExpired = (lastFetched) => {
  const now = new Date();
  const lastFetchedDate = new Date(lastFetched);
  const expirationDate = new Date();
  expirationDate.setHours(4, 0, 0, 0);

  // Se ao setar a hora para 4 da manha a data passar ser maior que a data atual,
  // então a data de expiração é o dia anterior pois ainda não passou das 4 da manhã
  if (expirationDate >= now) {
    expirationDate.setDate(expirationDate.getDate() - 1);
  }

  return expirationDate > lastFetchedDate;
};

const getAnonymousHistory = () => {
  const localStorageKey = `_ht-base`;
  const localData = JSON.parse(localStorage.getItem(localStorageKey));

  const result = [...(localData || [])]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 4);

  localStorage.setItem(localStorageKey, JSON.stringify(result));

  return result;
};

const mergeAndSortHistory = (services, localData) => {
  return [...(services || []), ...(localData || [])]
    .reduce((acc, item) => {
      if (!acc.some((existingItem) => existingItem.id === item.id)) {
        acc.push(item);
      }
      return acc;
    }, [])
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, MAX_HISTORY_ITEMS);
};

export const fetchUserHistory = (userId) => async (dispatch) => {
  dispatch(fetchUserHistoryRequest());

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT);

  const csrfToken = getCookie('XSRF-TOKEN');

  try {
    if (!userId || !csrfToken) {
      dispatch(fetchUserHistorySuccess(getAnonymousHistory()));
      return;
    }

    const localStorageKey = `_ht-${userId}`;
    const localData = JSON.parse(localStorage.getItem(localStorageKey));
    const lastFetched = localStorage.getItem(`${localStorageKey}_exp`);

    if (localData && lastFetched && !isDataExpired(lastFetched)) {
      dispatch(fetchUserHistorySuccess(localData));
      return;
    }

    const url = new URL(`/govbrportal/api/history`, window.location.origin);

    const response = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-XSRF-TOKEN': csrfToken,
      },
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    const data = await response.json();

    if (!response.ok) {
      dispatch(
        fetchUserHistoryFailure(data?.errors?.[0]?.code || 'UNEXPECTED_ERROR'),
      );
      return;
    }

    const services = mapUserHistoryOutput(data?.output?.services);

    if (!validateHistoryData(services)) {
      dispatch(fetchUserHistoryFailure('INVALID_DATA_FORMAT'));
      return;
    }

    const mergedData = mergeAndSortHistory(services, localData);

    localStorage.setItem(localStorageKey, JSON.stringify(mergedData));
    localStorage.setItem(`${localStorageKey}_exp`, new Date().toISOString());
    dispatch(fetchUserHistorySuccess(mergedData));
  } catch (error) {
    dispatch(fetchUserHistoryFailure(error.toString()));
  }
};
